import { render } from "./B2bFiltersProfiles.vue?vue&type=template&id=15e877e6&scoped=true&lang=pug"
import script from "./B2bFiltersProfiles.vue?vue&type=script&lang=js"
export * from "./B2bFiltersProfiles.vue?vue&type=script&lang=js"

import "./B2bFiltersProfiles.vue?vue&type=style&index=0&id=15e877e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e877e6"]])

export default __exports__